import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { florissantMOConfig } from "./data";

export default function FlorissantPage() {
  return <CityPageTemplate config={florissantMOConfig} />;
}